// Try to save some data to check if sessionStorage is not turned off in the Browser.
const supportsLocalStorage = (window: Window) => {
    try {
        const key = 'RIO_SUPPORTS_LOCAL_STORAGE';
        window.sessionStorage.setItem(key, 'true');
        const isSupported = window.sessionStorage.getItem(key);
        window.sessionStorage.removeItem(key);
        return isSupported;
    } catch (_) {
        console.warn('[feature/login] sessionStorage not supported!');
        return false;
    }
};

export const configureStorage = (window: Window) => {
    if (supportsLocalStorage(window)) {
        const { sessionStorage } = window;
        const routeKey = 'oauth_initial_route';
        return {
            discardRoute: () => sessionStorage.removeItem(routeKey),
            getRoute: () => sessionStorage.getItem(routeKey),
            saveRoute: (route: string) => sessionStorage.setItem(routeKey, route),
        };
    }

    console.warn('[feature/login] LocalStorage for saving "oauth_state" not available!');

    // This is bad, should we proceed and how?
    return {
        discardRoute: () => {},
        getRoute: () => '/',
        saveRoute: () => {},
    };
};

export const routeStorage = configureStorage(window ?? {});
